import { getQueryParams, httpApi } from '@api/FW/http.api';

/**
 * Get a list of available tax.gov.ua links based on check id.
 *
 * @param checkId - Check GUID.
 */
export const getECheck = (checkId: string): Promise<string[]> => {
	return httpApi
		.get(`Checks/URL/${checkId}`, {
			params: getQueryParams(),
		})
		.then(({ data }) => {
			//console.log(data)
			return data;
		})
		.catch((err) => {
			throw err;
		});
};

/**
 * Request a signed bill.
 *
 * @param checkId - Check GUID.
 * @param email - User email.
 */
export const getSignedBill = (checkId: string, email: string): Promise<string[]> => {
	return httpApi
		.post(
			`Checks/BillSignRequest/${checkId}`,
			{ Email: email },
			{
				params: getQueryParams(),
			},
		)
		.then(({ data }) => {
			console.log({ data });
			return data;
		})
		.catch((err) => {
			throw err;
		});
};
